import APP_1 from "@images/new_image/booom/app/1.png"
import APP_2 from "@images/new_image/booom/app/2.png"
import APP_3 from "@images/new_image/booom/app/3.png"
import APP_4 from "@images/new_image/booom/app/4.png"
import APP_5 from "@images/new_image/booom/app/5.png"
import APP_M from "@images/new_image/booom/app/modal.png"
import APP_Download from "@images/new_image/booom/app/Download_App.png"
import PC_Download from "@images/new_image/booom/pc/Download_Web.png"
import PC_1 from "@images/new_image/booom/pc/1.png"
import PC_2 from "@images/new_image/booom/pc/2.png"
import PC_3 from "@images/new_image/booom/pc/3.png"
import PC_4 from "@images/new_image/booom/pc/4.png"
import PC_5 from "@images/new_image/booom/pc/5.png"
import PC_M from "@images/new_image/booom/pc/modal.png"
import closeImg from "@images/new_image/close.png"
import Clickable from "@src/components/clickable"
import { AngleRight } from "@src/components/icon"
import { AppContext } from "@src/context"
import {
  booomGameIds,
  booomGames,
  booomGameUnvotableIds,
  booomGameVotableIds,
} from "@src/data/booom"
import { requestGapi } from "@src/utils/request"
import { shuffle } from "lodash"
import React, { useContext, useEffect, useState } from "react"
import styles from "./booom.module.scss"
import classnames from "@src/utils/classnames"
import classNames from "classnames"
import { config as wechatConfig, share as wechatShare } from "@src/utils/wechat"

const formatGames = (resGames, ids) => {
  const gamesData = booomGames
  const formatted = resGames
    .filter(game => ids.includes(game.id))
    .map(game => {
      const gameInData = gamesData.find(g => g.id === game.id)
      return {
        id: game.id,
        title: game.attributes.title,
        thumb: game.attributes.cover,
        tags: gameInData && gameInData.tags,
      }
    })
  return formatted
}

const Games = ({ games }) => {
  if (games.length === 0) {
    return "loading..."
  }
  return (
    <div className={classNames(styles.gamesContainer, "contentContainer")}>
      <ul className={styles.games}>
        {games.map(({ title, thumb, tags, id }) => {
          return (
            <li key={id}>
              <Clickable
                className={styles.game}
                appNavTo={`https://www.gcores.com/games/${id}`}
              >
                <img
                  src={`https://image.gcores.com/${thumb}?x-oss-process=image/resize,limit_1,m_fill,w_256,h_120/quality,q_90`}
                  alt={title}
                />
                <div className={styles.gameBody}>
                  <div>
                    <h3>{title.replace("【BOOOM】", "")}</h3>
                    <div className={styles.gameTags}>
                      {tags.map(tag => {
                        return <span key={tag}>{tag}</span>
                      })}
                    </div>
                  </div>
                  <AngleRight className={styles.gameRightIcon} />
                </div>
              </Clickable>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

const BooomPage = () => {
  const { renderItem, isAppLayout } = useContext(AppContext)
  const [awardModalVisible, setAwardModalVisible] = useState(false)
  const [downloadModalVisible, setDownloadModalVisible] = useState(false)
  const [votableGames, setVotableGames] = useState([])
  const [unvotableGames, setUnvotableGames] = useState([])

  useEffect(() => {
    requestGapi(
      `games?filter[id]=${booomGameIds.join(
        ","
      )}&page[limit]=100&fields[games]=cover,title`
    ).then(res => {
      const games = res.data
      setVotableGames(shuffle(formatGames(games, booomGameVotableIds)))
      setUnvotableGames(shuffle(formatGames(games, booomGameUnvotableIds)))
    })
  }, [])

  useEffect(() => {
    wechatConfig()
    wechatShare({
      link: "https://site.gcores.com/game_rally/booom",
      title: "BOOOM 线上试玩 & 评选会",
      desc: "经过18天，有73款游戏在这次的活动上诞生，来一起试试吧～",
    })
  }, [])

  return (
    <>
      {(awardModalVisible || downloadModalVisible) && (
        <div
          id="modalBg"
          className={styles.modalBg}
          onClick={e => {
            if (e.target.getAttribute("id") === "modalBg") {
              setAwardModalVisible(false)
              setDownloadModalVisible(false)
            }
          }}
        >
          {awardModalVisible && (
            <Clickable
              className="container"
              onClick={() => {
                setAwardModalVisible(false)
              }}
            >
              {renderItem(PC_M, APP_M)}
            </Clickable>
          )}
          {downloadModalVisible && (
            <div className={styles.downloadModal}>
              <Clickable
                onClick={() => {
                  setDownloadModalVisible(false)
                }}
                className={styles.downloadModalClose}
              >
                <img src={closeImg} alt="关闭" />
              </Clickable>
              <div className={styles.downloadModalHead}>游戏下载</div>
              <div className={styles.downloadModalBody}>
                <div>
                  <div>
                    <small>链接</small>
                  </div>
                  <div>
                    <Clickable
                      appNavTo="http://site.gcores.com/booom_download/BOOOM作品/allinone.zip"
                      download="allinone.zip"
                    >
                      http://site.gcores.com/booom_download/BOOOM作品/allinone.zip
                    </Clickable>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <div className={classnames("page", styles.page)}>
        <div className="container">
          {renderItem(PC_1, APP_1)}
          {/* <Clickable
            onClick={() => {
              setAwardModalVisible(true)
            }}
          >
            {renderItem(PC_2, APP_2)}
          </Clickable> */}
          <Clickable
            onClick={() => {
              setDownloadModalVisible(true)
            }}
          >
            {renderItem(PC_Download, APP_Download)}
          </Clickable>
          {/* {renderItem(PC_3, APP_3)}
          <Games games={votableGames} />
          {renderItem(PC_4, APP_4)}
          <Games games={unvotableGames} /> */}
          <Games games={votableGames.concat(unvotableGames)} />
        </div>
        <div className={isAppLayout ? undefined : styles.pcFooter}>
          <div className="container">{renderItem(PC_5, APP_5)}</div>
        </div>
      </div>
    </>
  )
}

export default BooomPage
